import { Close } from '@mui/icons-material';
import React from 'react';
import DeleteItem from './deleteItem';
import { setAlertWithTitle } from '../../../utility/Redux/modal';

const OrderColumns = (
  windowWidth,
  prefix,
  sid,
  token,
  icode,
  dispatch,
  setOrderDetails,
  date,
  setAlertTwoButtonModal,
  alertTwoButtonModal
) => {
  const c = [
    {
      field: 'ICODE',
      type: 'string',
      width: windowWidth <= 768 ? 80 : windowWidth <= 1024 ? 80 : 110,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <strong style={{ fontSize: 13 }}>{'Code'}</strong>
      ),
    },
    {
      field: 'ITEMNAME',
      type: 'string',
      width: windowWidth <= 768 ? 80 : windowWidth <= 1024 ? 150 : 300,
      align: 'left',

      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <strong style={{ fontSize: 13 }}>{'Item Name'}</strong>
      ),
    },

    {
      field: 'ORDER_QNTY',
      type: 'string',
      width: windowWidth <= 768 ? 150 : windowWidth <= 1024 ? 150 : 130,
      align: 'right',
      renderCell: (params) => {
        return <div className="font-semibold">{params.value}</div>;
      },
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <strong style={{ fontSize: 13 }}>{'Order Qnty'}</strong>
      ),
    },
    {
      field: 'REMARKS',
      type: 'string',
      width: windowWidth <= 768 ? 120 : windowWidth <= 1024 ? 150 : 250,
      align: 'left',
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <strong style={{ fontSize: 13 }}>{'Remarks'}</strong>
      ),
    },
    {
      field: 'EMPLOYEE_NAME',
      type: 'string',
      width: windowWidth <= 768 ? 120 : windowWidth <= 1024 ? 150 : 250,
      align: 'left',
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-between  w-full">
            <div>{params.value}</div>

            <button
              onClick={() => {
                if (params.row.FNO === 0) {
                  setAlertTwoButtonModal({
                    ...alertTwoButtonModal,
                    status: true,
                    title: 'Alert',
                    msg: 'Are you sure you want to delete this Item ?',
                    button1: 'Yes',
                    button2: 'Cancel',

                    button1Click: () => {
                      DeleteItem(
                        prefix,
                        sid,
                        token,
                        params.row.ICODE,
                        params.row.SERIAL_NO,
                        dispatch,
                        setOrderDetails,
                        date
                      );
                      setAlertTwoButtonModal({
                        ...alertTwoButtonModal,
                        status: false,
                      });
                    },
                    button2Click: () => {
                      setAlertTwoButtonModal({
                        ...alertTwoButtonModal,
                        status: false,
                      });
                    },
                  });
                } else {
                  dispatch(
                    setAlertWithTitle({
                      title: 'Alert',
                      msg: 'Items already isssued againt this order',
                    })
                  );
                }
              }}
            >
              <Close
                fontSize={'small'}
                style={{
                  color: 'red',
                }}
              />
            </button>
          </div>
        );
      },
      renderHeader: (params) => (
        <strong style={{ fontSize: 13 }}>{'Employee Name'}</strong>
      ),
    },
  ];
  return c;
};

export default OrderColumns;
